/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { z } from 'zod';
import { baseChallengeTranslationBodySchema } from '../challenge-translation-body-schema';

export const createChallengeTranslationBodySchema = baseChallengeTranslationBodySchema;

export type ICreateChallengeTranslationBody = z.infer<typeof createChallengeTranslationBodySchema>;

export interface ICreateChallengeTranslationRequest {
  challengeId: number;
  body: ICreateChallengeTranslationBody;
}
